import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useStore } from 'effector-react';
import { Badge, Folder, LongText, Preview, Tabs, WithSumIcon } from '@gmini/ui-kit';
import * as smApi from '@gmini/sm-api-sdk';
import { TreeLoader } from '@gmini/ui-kit/lib/TreeLoader/TreeLoader';
import { TreeContext } from "../../../../classifier-editor/ClassifierTree/TreeContext";
import { currentGroup$, isGeneralGroupNode, setCurrentGroup } from "../../../ClassifierTree";
import { filterNotExpandedTree } from "../../../ClassifierTree/createTree";
import { NodeContainer } from "../../../ClassifierTree/NodeContainer/NodeContainer";
import { emptyGroupingCondition } from "../../constants";
import { VirtualizedTree } from "../../../ClassifierTree/VirtualizedTree";
import { importEstimationService } from "../../model";
import { buildKeyByPath } from "../../../ClassifierTree/utils";
import { NodeLayout } from "../../../ClassifierTree/NodeLayout";
import { useSelectedGroupNode } from "../../helpers/useSelectedGroupNode";
import { RuleEditor } from "../RuleEditor";
import { GroupingsPreview } from "../GroupingsPreview";
import { isUserClassifierGroupNode } from "../../../../classifier-service/Node";
import { getUserClassifierGroupNode } from "../../helpers/getUserClassifierGroupNode";
import { WithDotsIcon } from "../WithDotsIcon";
import { useCtxData } from "../itemPropsCtx";
import { EntityName, Header, HeaderTitle, PreviewContent, PreviewGroupSettings, PreviewGroupSettingsContent, PreviewGroupSettingsHeader, PreviewGroups, PreviewGroupsContent, PreviewGroupsHeader, PreviewGroupsHeaderTitle, Wrapper } from "./EstimationPreview.styled";
import { mockPropsNodeContainer } from "./mockPropsNodeContainer";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TabIndex; //TODO: сделать Preview не привязанным к Estimation, что бы он мог работать с любыми сущностями

(function (TabIndex) {
  TabIndex[TabIndex["Calculations"] = 0] = "Calculations";
  TabIndex[TabIndex["Grouping"] = 1] = "Grouping";
})(TabIndex || (TabIndex = {}));

export var EstimationPreview = function EstimationPreview() {
  var activeEstimation = useStore(importEstimationService.activeEstimation$, {
    loc: {
      file: _effectorFileName,
      line: 79,
      column: 27
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [79, 27]"
  });
  var fetchActiveEstimationPending = useStore(importEstimationService.fetchActiveEstimationPending$, {
    loc: {
      file: _effectorFileName,
      line: 80,
      column: 39
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [80, 39]"
  });
  var activeCurrentUserClassifier = useStore(importEstimationService.activeCurrentClassifier$, {
    loc: {
      file: _effectorFileName,
      line: 83,
      column: 38
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [83, 38]"
  });
  var flatTree = useStore(importEstimationService.treeModel.flatTree$, {
    loc: {
      file: _effectorFileName,
      line: 86,
      column: 19
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [86, 19]"
  });
  var expanded = useStore(importEstimationService.expandModel.expanded$, {
    loc: {
      file: _effectorFileName,
      line: 87,
      column: 19
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [87, 19]"
  });
  var selectedPath = useStore(currentGroup$, {
    loc: {
      file: _effectorFileName,
      line: 88,
      column: 23
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [88, 23]"
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      firstSelected = _useState2[0],
      setFirstSelected = _useState2[1];

  var fetchActiveEstimationDataPending = useStore(importEstimationService.fetchActiveEstimationDataPending$, {
    loc: {
      file: _effectorFileName,
      line: 90,
      column: 43
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [90, 43]"
  });
  var fetchDynamicGroupItemActiveEstimationPending = useStore(importEstimationService.fetchDynamicGroupItemActiveEstimation.pending$, {
    loc: {
      file: _effectorFileName,
      line: 93,
      column: 55
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [93, 55]"
  });
  var selectedGroup = useSelectedGroupNode({
    nodes$: importEstimationService.classifierService.nodes$
  });
  var nodes = useStore(importEstimationService.classifierService.nodes$, {
    loc: {
      file: _effectorFileName,
      line: 99,
      column: 16
    },
    name: "EstimationPreview",
    sid: "EstimationPreview /src/classifier-editor/ImportEstimation/components/EstimationPreview/EstimationPreview.tsx [99, 16]"
  });

  var _useState3 = useState(TabIndex.Calculations),
      _useState4 = _slicedToArray(_useState3, 2),
      tabIndex = _useState4[0],
      setTabIndex = _useState4[1];

  useEffect(function () {
    setFirstSelected(false);
  }, [activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.id]);
  useEffect(function () {
    if (!firstSelected && flatTree.length) {
      var firstNode = flatTree[0];
      setCurrentGroup({
        path: firstNode.path
      });
      setFirstSelected(true);
    }
  }, [firstSelected, flatTree, activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.id]);
  useEffect(function () {
    if (!activeEstimation || !(selectedGroup !== null && selectedGroup !== void 0 && selectedGroup.id) || !activeEstimation.classifierId || !activeEstimation.classifierVersion) {
      return;
    }

    smApi.UserClassifierGroup.Property.List.fetchElementProperties.defaultContext({
      classifierId: activeEstimation.classifierId,
      classifierVersion: activeEstimation.classifierVersion,
      groupId: selectedGroup.id
    });
  }, [selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id, activeEstimation]);

  var onClickGroupContent = function onClickGroupContent() {
    if (activeEstimation !== null && activeEstimation !== void 0 && activeEstimation.id) {
      seoEventManager.push({
        event: 'Gtech_Estimation_ImportTemplateStructure_DiscoverClick',
        payload: {
          estimationId: estimationId,
          templateEstimationId: activeEstimation.id,
          sectionClick: 'Структура'
        }
      });
    }
  };

  var onClickRules = function onClickRules() {
    if (activeEstimation !== null && activeEstimation !== void 0 && activeEstimation.id) {
      seoEventManager.push({
        event: 'Gtech_Estimation_ImportTemplateStructure_DiscoverClick',
        payload: {
          estimationId: estimationId,
          templateEstimationId: activeEstimation.id,
          sectionClick: 'Условия'
        }
      });
    }
  };

  var onClickGroupings = function onClickGroupings() {
    if (activeEstimation !== null && activeEstimation !== void 0 && activeEstimation.id) {
      seoEventManager.push({
        event: 'Gtech_Estimation_ImportTemplateStructure_DiscoverClick',
        payload: {
          estimationId: estimationId,
          templateEstimationId: activeEstimation.id,
          sectionClick: 'Группировки'
        }
      });
    }
  };

  var handleChange = function handleChange(newTabIndex) {
    setTabIndex(newTabIndex);

    if (newTabIndex === TabIndex.Calculations) {
      onClickRules();
    } else {
      onClickGroupings();
    }
  };

  var childrenHasRule = importEstimationService.useChildrenHasRule();
  var itemRenderer = useCallback(function (_ref) {
    var item = _ref.item;
    var key = buildKeyByPath(item.path);
    var isExpanded = expanded[key];
    return /*#__PURE__*/_jsx(NodeContainer, _objectSpread(_objectSpread({
      item: item,
      isExpanded: isExpanded,
      nodes$: importEstimationService.classifierService.nodes$,
      toggle: function toggle(n) {
        var nextExpanded = !isExpanded;
        importEstimationService.expandModel.setItemExpanded({
          key: key,
          value: nextExpanded
        });
      },
      currentEntity: activeCurrentUserClassifier,
      selectedPath: selectedPath,
      renderNodeLayout: function renderNodeLayout(_ref2) {
        var _activeEstimation$cal;

        var nodeLayoutProps = _ref2.nodeLayoutProps,
            path = _ref2.path,
            node = _ref2.node,
            treeItem = _ref2.treeItem;

        var nextProps = _objectSpread({}, nodeLayoutProps);

        nextProps.onClick = function () {
          var _nodeLayoutProps$onCl;

          (_nodeLayoutProps$onCl = nodeLayoutProps.onClick) === null || _nodeLayoutProps$onCl === void 0 ? void 0 : _nodeLayoutProps$onCl.call(nodeLayoutProps);
          setCurrentGroup({
            path: path
          });
        };

        var hasCalculation = activeEstimation === null || activeEstimation === void 0 ? void 0 : (_activeEstimation$cal = activeEstimation.calculations) === null || _activeEstimation$cal === void 0 ? void 0 : _activeEstimation$cal.some(function (_ref3) {
          var groupId = _ref3.groupId;
          return groupId === node.id;
        });

        if (isGeneralGroupNode(node)) {
          var hasRule = childrenHasRule(node.id);

          if (hasCalculation) {
            nextProps.icon = /*#__PURE__*/_jsx(WithSumIcon, {
              icon: nextProps.icon
            });
          }

          if (hasRule) {
            nextProps.icon = /*#__PURE__*/_jsx(WithDotsIcon, {
              withIcon: !!hasCalculation,
              greenDot: hasRule,
              children: nextProps.icon
            });
          }
        }

        return /*#__PURE__*/_jsx(NodeLayout, _objectSpread({}, nextProps));
      }
    }, mockPropsNodeContainer), {}, {
      readonly: true
    }));
  }, [activeCurrentUserClassifier, activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.calculations, childrenHasRule, expanded, selectedPath]);
  var flatVisibleTree = useMemo(function () {
    return filterNotExpandedTree({
      tree: flatTree,
      expanded: expanded
    });
  }, [expanded, flatTree]);
  var countConditions = useMemo(function () {
    var _activeEstimation$cal2, _activeEstimation$cal3, _activeEstimation$cal4, _activeEstimation$cal5;

    return ((activeEstimation === null || activeEstimation === void 0 ? void 0 : (_activeEstimation$cal2 = activeEstimation.calculations) === null || _activeEstimation$cal2 === void 0 ? void 0 : (_activeEstimation$cal3 = _activeEstimation$cal2.find(function (_ref4) {
      var groupId = _ref4.groupId;
      return (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id) === groupId;
    })) === null || _activeEstimation$cal3 === void 0 ? void 0 : _activeEstimation$cal3.complexFields.length) || 0) + ((activeEstimation === null || activeEstimation === void 0 ? void 0 : (_activeEstimation$cal4 = activeEstimation.calculations) === null || _activeEstimation$cal4 === void 0 ? void 0 : (_activeEstimation$cal5 = _activeEstimation$cal4.find(function (_ref5) {
      var groupId = _ref5.groupId;
      return (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id) === groupId;
    })) === null || _activeEstimation$cal5 === void 0 ? void 0 : _activeEstimation$cal5.simpleFields.length) || 0);
  }, [activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.calculations, selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id]);
  var userClassifierGroup = selectedGroup ? isUserClassifierGroupNode(selectedGroup) ? selectedGroup : getUserClassifierGroupNode(selectedGroup, nodes) : null;
  var dynamicGroupConditions = useMemo(function () {
    return (activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.dynamicGroupList) || [];
  }, [activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.dynamicGroupList]);
  var currentGroupConditions = useMemo(function () {
    var _dynamicGroupConditio;

    return (_dynamicGroupConditio = dynamicGroupConditions.find(function (_ref6) {
      var sourceGroupId = _ref6.sourceGroupId;
      return sourceGroupId === (userClassifierGroup === null || userClassifierGroup === void 0 ? void 0 : userClassifierGroup.id);
    })) === null || _dynamicGroupConditio === void 0 ? void 0 : _dynamicGroupConditio.groupingConditions;
  }, [dynamicGroupConditions, userClassifierGroup === null || userClassifierGroup === void 0 ? void 0 : userClassifierGroup.id]);
  var groupingConditions = useMemo(function () {
    return currentGroupConditions || [_objectSpread({}, emptyGroupingCondition)];
  }, [currentGroupConditions]);

  var renderBadgeCondition = function renderBadgeCondition(_ref7) {
    var hoverTab = _ref7.hoverTab;
    return countConditions > 0 ? /*#__PURE__*/_jsx(Badge, {
      bgColor: tabIndex === TabIndex.Calculations || hoverTab ? '#4C5ECF' : '#A2A3B7',
      children: countConditions
    }) : null;
  };

  var renderBadgeGrouping = function renderBadgeGrouping(_ref8) {
    var hoverTab = _ref8.hoverTab;
    var count = currentGroupConditions === null || currentGroupConditions === void 0 ? void 0 : currentGroupConditions.length;
    return Number(count) > 0 ? /*#__PURE__*/_jsx(Badge, {
      bgColor: tabIndex === TabIndex.Grouping || hoverTab ? '#4C5ECF' : '#A2A3B7',
      children: count
    }) : null;
  };

  var dynamicGroupsConditionsMap = activeEstimation !== null && activeEstimation !== void 0 && activeEstimation.classifierId ? _defineProperty({}, activeEstimation.classifierId, activeEstimation.dynamicGroupList) : {};

  var _useCtxData = useCtxData(),
      seoEventManager = _useCtxData.seoEventManager,
      estimationId = _useCtxData.estimationId;

  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsxs(HeaderTitle, {
        children: [/*#__PURE__*/_jsx(Preview, {}), " \u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440:"]
      }), (activeEstimation === null || activeEstimation === void 0 ? void 0 : activeEstimation.name) && /*#__PURE__*/_jsx(EntityName, {
        children: /*#__PURE__*/_jsx(LongText, {
          partSize: 20,
          withoutRightText: true,
          children: activeEstimation.name
        })
      })]
    }), /*#__PURE__*/_jsxs(PreviewContent, {
      children: [/*#__PURE__*/_jsx(TreeLoader, {
        loading: fetchActiveEstimationPending || fetchActiveEstimationDataPending,
        text: "\u0418\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
      }), /*#__PURE__*/_jsxs(PreviewGroups, {
        children: [/*#__PURE__*/_jsx(PreviewGroupsHeader, {
          children: /*#__PURE__*/_jsx(PreviewGroupsHeaderTitle, {
            children: "\u041C\u043E\u0438 \u0440\u0430\u0441\u0447\u0435\u0442\u044B"
          })
        }), /*#__PURE__*/_jsx(PreviewGroupsContent, {
          onClick: onClickGroupContent,
          children: /*#__PURE__*/_jsx(TreeContext.Provider, {
            value: {
              tree: flatTree,
              dynamicGroupsConditions: dynamicGroupsConditionsMap,
              nodes: nodes
            },
            children: /*#__PURE__*/_jsx(VirtualizedTree, {
              rowHeight: function rowHeight(node) {
                return node.path.length === 1 ? 34 : 30;
              },
              flatTree: flatVisibleTree,
              itemRenderer: itemRenderer
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(PreviewGroupSettings, {
        children: [/*#__PURE__*/_jsxs(PreviewGroupSettingsHeader, {
          children: [/*#__PURE__*/_jsx(Folder, {}), /*#__PURE__*/_jsx(PreviewGroupsHeaderTitle, {
            children: "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0444\u043E\u0440\u043C\u0443\u043B:"
          })]
        }), /*#__PURE__*/_jsx(PreviewGroupSettingsContent, {
          children: /*#__PURE__*/_jsx(Tabs, {
            onChangeTab: handleChange,
            activeTabIndex: tabIndex,
            headerStyles: {
              fontSize: '14px',
              marginRight: '24px'
            },
            contentStyles: {
              height: '100%',
              padding: '0',
              flex: 1
            },
            tabs: [{
              title: 'Условия',
              dataTestId: 'tabConditions',
              content: selectedGroup ? /*#__PURE__*/_jsx(RuleEditor, {
                currentGroup: selectedGroup,
                onClick: onClickRules
              }) : null,
              renderBadge: renderBadgeCondition
            }, {
              title: 'Группировки',
              dataTestId: 'tabGroupings',
              content: selectedGroup ? /*#__PURE__*/_jsx(GroupingsPreview, {
                pending: fetchDynamicGroupItemActiveEstimationPending,
                groupingConditions: groupingConditions,
                onClick: onClickGroupings
              }) : null,
              renderBadge: renderBadgeGrouping
            }]
          })
        })]
      })]
    })]
  });
};